export const someDocumentsSelected = boxes => {
    let counter = 0;
    Object.keys(boxes).forEach(c => {
      if (boxes[c]) {
        counter++;
      }
    });
    return counter > 0;
  };
